import { makeStyles, tokens } from "@fluentui/react-components";

export const useTextStyles = makeStyles({
    subtleText: {
        color: tokens.colorNeutralForeground3 //colorNeutralStrokeAccessible,
    },
    field: {
        fontWeight: tokens.fontWeightSemibold,
    },
    truncatedText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },    
});